module.exports = "https://static.wmbcdn.com/uniweb/images/40a1175d72f90cf149e7a8b03f5986db.svg";